/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedRoomListSchema } from '../models/PagedRoomListSchema';
import type { RoomCreateSchema } from '../models/RoomCreateSchema';
import type { RoomDetailSchema } from '../models/RoomDetailSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RoomsApi {
    /**
     * Create Room
     * Create room. <br>Required Permission: create_room
     * @returns RoomDetailSchema OK
     * @throws ApiError
     */
    public static roomsCreateRoomPost({
        requestBody,
    }: {
        requestBody: RoomCreateSchema,
    }): CancelablePromise<RoomDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/rooms/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Room List
     * Get room list. <br>Required Permission: list_rooms
     * @returns PagedRoomListSchema OK
     * @throws ApiError
     */
    public static roomsGetRoomListGet({
        orderBy,
        limit = 100,
        offset,
    }: {
        orderBy?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedRoomListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/rooms/',
            query: {
                'order_by': orderBy,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Delete Room
     * Delete room. <br>Required Permission: delete_room
     * @returns void
     * @throws ApiError
     */
    public static roomsDeleteRoomDelete({
        roomId,
    }: {
        roomId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/rooms/{room_id}/',
            path: {
                'room_id': roomId,
            },
        });
    }
    /**
     * Get Room Detail
     * Get room detail. <br>Required Permission: get_room_detail
     * @returns RoomDetailSchema OK
     * @throws ApiError
     */
    public static roomsGetRoomDetailGet({
        roomId,
    }: {
        roomId: string,
    }): CancelablePromise<RoomDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/rooms/{room_id}/',
            path: {
                'room_id': roomId,
            },
        });
    }
    /**
     * Update Room
     * Update room. <br>Required Permission: update_room
     * @returns RoomDetailSchema OK
     * @throws ApiError
     */
    public static roomsUpdateRoomPut({
        roomId,
        requestBody,
    }: {
        roomId: string,
        requestBody: RoomCreateSchema,
    }): CancelablePromise<RoomDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/rooms/{room_id}/',
            path: {
                'room_id': roomId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
